import { AxiosPromise } from 'axios';

import {
	IMapFeatureLayerPayload,
	IMapFeatureSourcePayload,
	IVaporIO
} from '../../interfaces';
import {
	get,
	patch,
	post,
	remove
} from '../../lib';

declare const vaporio: IVaporIO;
const host = vaporio.api;

export async function getLayers(): Promise<AxiosPromise> {
	return get(`${host}/layers/?tile_name=fiber`);
}

export async function getSources(): Promise<AxiosPromise> {
	return get(`${host}/sources/`);
}

export async function postLayer(formData: IMapFeatureLayerPayload): Promise<AxiosPromise> {
	return post(`${host}/layers/`, {
		data: formData,
		headers: { 'Content-Type': 'multipart/form-data' }
	});
}

export async function postSource(source: IMapFeatureSourcePayload): Promise<AxiosPromise> {
	return post(`${host}/sources/`, { data: source });
}

export async function postTileserverUpdate(assetPath: string): Promise<AxiosPromise> {
	return post(`${host}/tileserver-update/`, { data: { asset_path: assetPath } });
}

export async function patchSource(sourceID: string, source: IMapFeatureSourcePayload): Promise<AxiosPromise> {
	return patch(`${host}/sources/${sourceID}`, { data: source });
}

export async function deleteLayer(layerID: string): Promise<AxiosPromise> {
	return remove(`${host}/layers/${layerID}`);
}

export async function deleteSource(sourceID: string): Promise<AxiosPromise> {
	return remove(`${host}/sources/${sourceID}`);
}
